import { Table } from "@common/data-models/complex-types/table";
import { IDeepCopy } from "@common/interfaces/i-deep-copy";

export class AttachmentListItem {
    constructor(
        public database?: string,
        public path?: string,
        public guid?: string,
        public title?: string
    ) { }

    public equals(target: AttachmentListItem): boolean {
        if (!target) return false;
        return (
            (this.database == target.database) &&
            (this.path == target.path) &&
            (this.guid == target.guid) &&
            (this.title == target.title)
        );
    }
}

export class AttachmentList implements IDeepCopy<AttachmentListItem> {
    public items: Array<AttachmentListItem> = [];

    public clear() {
        this.items = [];
    }

    public add(item: AttachmentListItem) {
        this.items.push(item);
    }

    public remove(guid: string) {
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].guid == guid) {
                this.items.splice(i, 1);
            }
        }
    }

    public equals(target: AttachmentList): boolean {
        if (!target) {
            return (this.items.length == 0);
        }

        for (let i = 0; i < this.items.length;i++) {
            if (!this.items[i].equals(target.items[i])) return false;
        }

        return true;
    }

    public static toTable(attachmentList: AttachmentList): Table {
        let ret = new Table();
        if (attachmentList && attachmentList.items) {
            for (let i = 0; i < attachmentList.items.length; i++) {
                let attachment = attachmentList.items[i];
                ret.set(i, 0, attachment.database);
                ret.set(i, 1, attachment.path);
                ret.set(i, 2, attachment.guid);
                ret.set(i, 3, attachment.title);
            }
        }
        return ret;
    }

    public static fromTable(table: Table): AttachmentList {
        let ret = new AttachmentList();
        if (table) {
            for (let i = 0; i < table.getRowCount(); i++) {
                ret.items.push(new AttachmentListItem(table.get(i, 0), table.get(i, 1), table.get(i, 2), table.get(i, 3)));
            }
        }
        return ret;
    }

    public deepCopy(): AttachmentList {
        let ret = new AttachmentList();
        for (let item of this.items) {
            ret.items.push(item);
        }
        return ret;
    }
}
